module.exports = __webpack_public_path__ + "img/video11.29db3acc.jpg";